const SET_USERID = 'setUser'

export default {
  [SET_USERID] (state, user) {
    state.user = user
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js